import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import Chortke from 'modules/Chortke/Chortke';
import {useCallback} from 'react';

function ChortkePageElement() {
  const {updateHeaderData} = useRouteBuildContext();
  const handleHeaderData = useCallback(
    ({icon, action, iconTitle}: HeaderDataPayload) => {
      updateHeaderData('chortke', {icon, action, iconTitle});
    },
    [updateHeaderData]
  );

  return <Chortke headerData={handleHeaderData} />;
}

export function createChortkeRoute(): PageRouteConfig {
  return {
    element: <ChortkePageElement />,
    layout: {
      title: 'چرتکه',
      hasNavigate: true,
      hasBack: false,
      hasHeader: true,
      headerDataKey: 'chortke'
    },
    initialHeaderData: {
      chortke: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
